import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Mail-Send-Envelope--Streamline-Flex"
    >
        <desc>
            {'Mail Send Envelope Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="mail-send-envelope--envelope-email-message-unopened-sealed-close">
            <path
                id="Vector 15"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.09363 3.14994C2.45775 4.4686 3.87859 5.68979 5.4402 6.7662c0.94096 0.64859 2.1785 0.64858 3.11945 -0.00002C10.1213 5.68976 11.5421 4.46856 12.9062 3.1499"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.60128 1.68374c-0.73161 0.0699 -1.41366 0.3475 -1.93494 0.78755 -0.52127 0.44004 -0.851014 1.01657 -0.935461 1.63557C0.606079 5.04865 0.499999 6.0142 0.499999 7c0 0.9858 0.10608 1.95223 0.23088 2.89314 0.084447 0.61896 0.414191 1.19556 0.935461 1.63556 0.52128 0.4401 1.20333 0.7177 1.93494 0.7876 1.10552 0.1003 2.2412 0.1848 3.39872 0.1848 1.15752 0 2.2932 -0.0845 3.3998 -0.1848 0.7316 -0.0699 1.4136 -0.3475 1.9349 -0.7876 0.5213 -0.44 0.851 -1.0166 0.9355 -1.63556C13.3929 8.95135 13.5 7.9858 13.5 7c0 -0.9858 -0.1061 -1.95223 -0.2309 -2.89314 -0.0844 -0.619 -0.4142 -1.19553 -0.9354 -1.63557 -0.5213 -0.44005 -1.2034 -0.71765 -1.935 -0.78755C9.29424 1.5834 8.15856 1.4989 7 1.4989s-2.2932 0.0845 -3.39872 0.18484Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
